import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";


export const postContactInfo = async (formData) => {
    try {

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/contact`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;
    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getContact = async () => {
    try {

        const res = await axiosInstance.get(
            `/contact`
        );
        return res.data?.data;
    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}